import { render, staticRenderFns } from "./smartstudentid.vue?vue&type=template&id=37e9da49&scoped=true"
import script from "./smartstudentid.vue?vue&type=script&lang=js"
export * from "./smartstudentid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e9da49",
  null
  
)

export default component.exports